import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  EditButton,
  DateField,
  SaveButton,
  Toolbar,
  TabbedForm,
  FormTab,
  ImageInput,
  ImageField,
} from 'react-admin';

export const ImageFormatter = v => {
  // console.log("====LogoFormatter=====: ", v);
  if (typeof v === 'object') {
    return v;
  }
  const imageObj = {
    "src": v
  }
  return v
    ? imageObj
    : v;
}

export const ImageParser = v => {
  // console.log("====LogoParser=====: ", v);
  // console.log(v);
  if (typeof v === 'object') {
    return v;
  }

  return v.src
    ? v.src
    : v;
}

const required = (message = 'Required') =>
  value => value ? undefined : message;

export const ConfigList = (props) => (
  <List {...props} title="List of Configs" bulkActionButtons={false}>
    <Datagrid>
      <DateField source="created_at" showTime/>
      <TextField source="name"/>
      <TextField source="value"/>
      <DateField source="updated_at" showTime/>
      <EditButton/>
    </Datagrid>
  </List>
);

export const ConfigCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="/configs">
      <TextInput source="name" validate={required()}/>
      <TextInput source="value"/>
      {/*<ImageInput source="value" label="Photos" accept="image/*"*/}
                  {/*format={ImageFormatter} parse={ImageParser}>*/}
        {/*<ImageField source="src" title="title"/>*/}
      {/*</ImageInput>*/}
    </SimpleForm>
  </Create>
);

const EditToolbar = props => (
  <Toolbar {...props} >
    <SaveButton/>
  </Toolbar>
);

export const ConfigEdit = (props) => (
  <Edit {...props} undoable={false}>
    <TabbedForm redirect="/configs">
      <FormTab label="Config Info">
        <TextInput source="name" validate={required()}/>
        <TextInput source="value" />
        {/*<ImageInput source="value" label="Photos" accept="image/*"*/}
                    {/*format={ImageFormatter} parse={ImageParser}>*/}
          {/*<ImageField source="src" title="title"/>*/}
        {/*</ImageInput>*/}
      </FormTab>
    </TabbedForm>
  </Edit>
);